var s = /* @__PURE__ */ ((c) => (c.IDDesc = "IDDesc", c.IDAsc = "IDAsc", c.PriceDesc = "PriceDesc", c.PriceAsc = "PriceAsc", c))(s || {});
const A = 5, _ = 10, I = 1, E = 0.045, L = 10;
export {
  _ as APOSTLE_SKILL_MAX_LEVEL,
  I as APOSTLE_SKILL_MIN_LEVEL,
  L as BOUNTIES_PAGE_SIZE,
  E as BOUNTY_REWARD_MINUS_FRACTION,
  s as BountySortBy,
  A as MAX_APOSTLE_QUANTITY
};
//# sourceMappingURL=bounty.js.map
